<div class="saldo-minimo">
  <div class="lista-saldo">
      <h2>Saldo mínimo</h2> 
      <mat-slide-toggle [(ngModel)]="hasMinBalance" (change)="disableMinBalance($event)"></mat-slide-toggle>
  </div>
 
  <div class="values" *ngIf="hasMinBalance">
    <app-input-currency [inputModel]="minBalanceInputModel"  [(value)]="minBalanceToShow" class="value-payment"></app-input-currency>    
    
  </div>
  <button *ngIf="hasMinBalance" (click)="enableMinBalance()" class="confirma confirma-edit">
      Confirmar
  </button>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/notifications/notifications.component.html